import React, { memo } from 'react';
import { round } from 'mathjs';
import allStyles from '../../AllCharts.module.css';
import styles from './UserScore.module.css';
import { Typography } from 'antd';
const { Title, Text } = Typography;

const UserScore = memo(({ userScore, optionsData, setUserScorePopup }) => {
  const alertLevel = 'alertLevel' + round(((100 - userScore) * 4.9999) / 100);

  return (
    <div
      className={styles.userScoreWrapper}
      onClick={() => setUserScorePopup(true)}
    >
      <div
        className={allStyles.chartInnerCard}
        style={{
          boxShadow: '0px 0px 10px #0194a1',
          backgroundColor: optionsData[alertLevel],
          color: 'white',
          height: '100%',
        }}
      >
        <div className={styles.userScoreInnerContainer}>
          <Title level={3} style={{ margin: 0 }}>
            {userScore}%
          </Title>
          <Text style={{ margin: 0 }}>Get your highest score</Text>
        </div>
      </div>
    </div>
  );
});

export default UserScore;
